﻿import { FC } from 'react';
import { Section, Card, CardTitle, CardDescription, Alert, Button } from '../components/ui';
import { SEOHead } from '../components/seo';
import { ROUTES } from '../config/routes';
import { PageProps } from './HomePage';

export const PaymentSuccessPage: FC<PageProps> = ({ onNavigate }) => {
  return (
    <>
      <SEOHead title="Payment Success" noIndex={true} />
      <Section title="Payment Confirmation">
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <Card>
            <Alert variant="success" title="Payment Successful (Simulation)">
              Your payment has been successfully recorded. A confirmation email and secure download link have been dispatched.
            </Alert>
            <CardTitle style={{ marginTop: '1rem' }}>Order Confirmed</CardTitle>
            <CardDescription style={{ marginTop: '0.5rem', lineHeight: 1.6 }}>
              You may access your digital toolkit using the secure download portal.
            </CardDescription>
            <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
              <Button variant="primary" onClick={() => onNavigate(ROUTES.DOWNLOAD)}>
                Go to Download Center
              </Button>
              <Button variant="outline" onClick={() => onNavigate(ROUTES.HOME)}>
                Return Home
              </Button>
            </div>
          </Card>
        </div>
      </Section>
    </>
  );
};

